import { Button, ButtonTargetKind } from "src/components/Button";
import { Modal, ModalProps } from "src/components/Modal";
import { ButtonRole, ButtonSize } from "src/styles/button";
import { verticalStackCss, horizontalStackCss } from "src/theme/spacing";

interface MultiNonprofitLaunchModalProps extends Pick<ModalProps, "isOpen"> {
  onConfirm: () => void;
  onReject: () => void;
}

export const MultiNonprofitLaunchModal = (
  props: MultiNonprofitLaunchModalProps
) => {
  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={props.onReject}
      onAfterClose={props.onReject}
    >
      <div css={[verticalStackCss.s, { maxWidth: 440 }]}>
        <h5>Ready to launch your fundraiser?</h5>
        <p>
          Please note that once the fundraiser is launched, you will not be able
          to add or remove any nonprofits from this campaign. Ensure that all
          desired organizations are included before proceeding.
        </p>
        <div css={[horizontalStackCss.s, { justifyContent: "flex-end" }]}>
          <Button
            data-tname="fundraiserLaunchAbort"
            role={ButtonRole.TEXT_ONLY}
            size={ButtonSize.MEDIUM}
            onClick={{
              kind: ButtonTargetKind.FUNCTION,
              action: props.onReject,
            }}
          >
            Cancel
          </Button>
          <Button
            data-tname="fundraiserLaunchConfirm"
            data-bloom-block
            role={ButtonRole.PRIMARY}
            size={ButtonSize.MEDIUM}
            onClick={{
              kind: ButtonTargetKind.FUNCTION,
              action: props.onConfirm,
            }}
          >
            Launch Fundraiser
          </Button>
        </div>
      </div>
    </Modal>
  );
};
